export function getContextualRecommendationParams() {
    const metaTag = document.querySelector("[name='sailthru.cid']");
    return {
        context: metaTag ? metaTag.getAttribute("content") : undefined,
        contexttype: metaTag ? 1 : undefined
    };
}
